function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "path-1",
  fill: "#FFB71E",
  cx: 24.967945,
  cy: 24.9870586,
  rx: 24.967945,
  ry: 24.9870586
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(19.721098, 26.249188) rotate(-15.000000) translate(-15.721098, -23.249188) ",
  points: "34.7519014 11.6196833 23.0949826 14.2124478 25.9078478 17.059405 17.5483472 25.44468 11.4664765 19.3440574 -3.3097049 31.6758651 -0.116722771 34.8786919 11.4664765 25.7751303 17.5483472 31.8757529 29.1008299 20.2622319 32.1671064 23.3125432"
}));

var SvgBoost = function SvgBoost(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "-4 -4 58 58",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boost.47028889.svg";
export { ForwardRef as ReactComponent };